import { render, staticRenderFns } from "./BoletoFactura.vue?vue&type=template&id=43515998&scoped=true&"
import script from "./BoletoFactura.vue?vue&type=script&lang=js&"
export * from "./BoletoFactura.vue?vue&type=script&lang=js&"
import style0 from "./BoletoFactura.vue?vue&type=style&index=0&id=43515998&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43515998",
  null
  
)

export default component.exports